import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { del, get, post, patch } from "../../api/api";

// Listar paineis
export const listarPaineis = async () => {
  return await get<IRespostaFuncao<any[]>>(`/paineis`);
};

// Listar painel por Id
export const listarPainel = async (painelId: string) => {
  return await get<IRespostaFuncao<any[]>>(`/paineis/${painelId}`);
};

// Criar painel
export const criarPainel = async (
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await post<IRespostaFuncao<any>>(
    `/paineis/cria-painel`,
    payload
  );
};

// Atualizar painel
export const atualizarPainel = async (
  painelId: string,
  payload: any
): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(
    `/paineis/${painelId}/atualiza-painel`,
    payload
  );
};

// Deletar painel
export const deletarPainel = async (
  painelId: string
): Promise<IRespostaFuncao<any>> => {
  return await del<IRespostaFuncao<any>>(
    `/paineis/${painelId}/remove-painel`
  );
};

